export const extractFilename = (filename = "") => filename.split("_klp_")[0];
